import Vue from 'vue'
import Vuex from 'vuex'
import authenticate from "./modules/authenticate"
import lang from "./modules/lang"
import product from "./modules/product"
import productsInWarehouses from "./modules/productsInWarehouses"
import user from "./modules/user"
import warehouse from "./modules/warehouse"
import companyCount from "@/store/modules/companyCount";
import currency from "./modules/currency";
import currencyRate from "./modules/currencyRate";
import productCategory from "./modules/productCategory";
import productPurchase from "./modules/productPurchase";
import sale from "./modules/sale";
import company from "./modules/company";
import emailAvailability from "./modules/emailAvailability"
import employee from "./modules/employee"
import employeePosition from "./modules/employeePostition"
import customer from "./modules/customer";
import payme from "./modules/payme";
import importProductExcel from "./modules/importProductExcel";
import incomeAndOutcome from "@/store/modules/incomeAndOutcome";
import supplier from "@/store/modules/supplier";
import imageUpload from "@/store/local/imageUpload";
import ikpu from "@/store/modules/ikpu";
import purchase from "@/store/modules/purchase";
import saleProduct from "@/store/modules/saleProduct";
import saleDaily from "@/store/modules/saleDaily";
import saleMonthly from "@/store/modules/saleMonthly";
import saleYearly from "@/store/modules/saleYearly";
import saleEmployeeDaily from "@/store/modules/saleEmployeeDaily";
import saleEmployeeMonthly from "@/store/modules/saleEmployeeMonthly";
import saleEmployeeYearly from "@/store/modules/saleEmployeeYearly";
import saleCustomerDaily from "@/store/modules/saleCustomerDaily";
import saleCustomerMonthly from "@/store/modules/saleCustomerMonthly";
import saleCustomerYearly from "@/store/modules/saleCustomerYearly";
import saleProductDailyRating from "@/store/modules/saleProductDailyRating";
import saleProductMonthlyRating from "@/store/modules/saleProductMonthlyRating";
import saleProductYearlyRating from "@/store/modules/saleProductYearlyRating";
import service from "@/store/modules/service";
import discount from "@/store/modules/discount";
import autoOrder from "@/store/modules/autoOrder";
import scale from "@/store/modules/scale";
import inventory from "@/store/modules/inventory";
import tax from "@/store/modules/tax";
import location from "@/store/modules/location";
import modifyProduct from "@/store/modules/modifyProduct";
import browser from "@/store/modules/browser";
import employeeAtWork from "@/store/modules/employeeAtWork";
import epos from "@/store/modules/epos";
import kpi from "@/store/modules/kpi";
import innerBus from "@/store/modules/innerBus";
import incomeAndOutcomeCategory from "@/store/modules/incomeAndOutcomeCategory";
import saleServiceDailyStat from "@/store/modules/saleServiceDailyStat";
import saleServiceMonthlyStat from "@/store/modules/saleServiceMonthlyStat";
import saleServiceYearlyStat from "@/store/modules/saleServiceYearlyStat";
import cashbackNumberAvailability from "./modules/cashbackNumberAvailability";
import employeeBonusProduct from "@/store/modules/employeeBonusProduct";
import order from "@/store/modules/order";
import productDynamic from "@/store/modules/productDynamic";
import device from "@/store/modules/device";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        authenticate,
        autoOrder,
        browser,
        company,
        companyCount,
        currency,
        currencyRate,
        customer,
        cashbackNumberAvailability,
        discount,
        device,
        emailAvailability,
        employee,
        employeeAtWork,
        employeePosition,
        employeeBonusProduct,
        epos,
        incomeAndOutcome,
        innerBus,
        incomeAndOutcomeCategory,
        imageUpload,
        importProductExcel,
        ikpu,
        inventory,
        kpi,
        lang,
        location,
        payme,
        product,
        productCategory,
        productPurchase,
        productsInWarehouses,
        productDynamic,
        purchase,
        sale,
        saleDaily,
        saleMonthly,
        saleYearly,
        saleProduct,
        saleCustomerDaily,
        saleCustomerMonthly,
        saleCustomerYearly,
        saleEmployeeDaily,
        saleEmployeeMonthly,
        saleEmployeeYearly,
        saleProductDailyRating,
        saleProductMonthlyRating,
        saleProductYearlyRating,
        saleServiceDailyStat,
        saleServiceMonthlyStat,
        saleServiceYearlyStat,
        service,
        supplier,
        scale,
        tax,
        modifyProduct,
        user,
        warehouse,
        order
    },
})
